// extracted by mini-css-extract-plugin
export default {"container":"DropDownMenu_container__brqKM","valueText":"DropDownMenu_valueText__Btq0h","rightArrowImage":"DropDownMenu_rightArrowImage__VcZa4"};